import React, { Component } from "react";
import { post } from "../../../util/api";
import {
  Grid,
  Header,
  Icon,
  Segment,
  Card,
  Statistic,
  Table,
  Button,
} from "semantic-ui-react";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import * as XLSX from "xlsx";

class CommentQuestionAnalytic extends Component {
  state = {
    loading: true,
    comments: [],
    questions: [],
    commentLimit: 5,
    questionLimit: 5,
  };

  componentDidMount() {
    this.loadData();
  }

  componentDidUpdate(oldProps) {
    if (
      this.props.start_date !== oldProps.start_date ||
      this.props.end_date !== oldProps.end_date
    ) {
      this.loadData();
    }
  }

  async loadData() {
    try {
      if (!this.props.product || !this.props.product.personalize) {
        this.setState({ loading: false });
        return;
      }

      let { start_date, end_date } = this.props;
      let { id } = this.props.product.personalize;
      let pid = id;

      const [commentsResponse, questionsResponse] = await Promise.all([
        post("/personalize/getCommentWithAdmin/list", {
          pid,
          start_date,
          end_date,
        }),
        post("/personalize/question", {
          pid,
          start_date,
          end_date,
        }),
      ]);

      this.setState({
        loading: false,
        comments: commentsResponse.data.success
          ? commentsResponse.data.result
          : [],
        questions: questionsResponse.data.success
          ? questionsResponse.data.result
          : [],
      });
    } catch (error) {
      console.error("Veri yükleme hatası:", error);
      this.setState({ loading: false });
    }
  }

  groupByProduct(data) {
    const groups = {};
    data.forEach((item) => {
      const pId = item.product_id;
      const pName =
        item.extra?.productName || item.extra?.name_firm || "Ürün ID: " + pId;

      let pLink = item.extra?.absolute_url || item.extra?.product_link || "#";

      if (pLink !== "#" && !pLink.startsWith("http")) {
        pLink = "https://" + pLink;
      }

      if (!groups[pId]) {
        groups[pId] = { id: pId, name: pName, link: pLink, count: 0 };
      }
      groups[pId].count += 1;
    });
    return Object.values(groups).sort((a, b) => b.count - a.count);
  }

  getNegativeStats() {
    const { comments } = this.state;
    const negativeComments = comments.filter(
      (c) => c.extra && c.extra.rate < 3
    );
    const totalNegativeCount = negativeComments.length;

    if (totalNegativeCount === 0) return [];

    const groups = {};
    negativeComments.forEach((item) => {
      const pId = item.product_id;
      const pName = item.extra?.productName || "Ürün ID: " + pId;
      let pLink = item.extra?.absolute_url || "#";

      if (pLink !== "#" && !pLink.startsWith("http")) {
          pLink = "https://" + pLink;
      }

      if (!groups[pId]) {
        groups[pId] = { id: pId, name: pName, link: pLink, count: 0 };
      }
      groups[pId].count += 1;
    });

    return Object.values(groups)
      .map((item) => ({
        ...item,
        percentage: ((item.count / totalNegativeCount) * 100).toFixed(1),
      }))
      .sort((a, b) => b.count - a.count);
  }

  downloadExcel = () => {
    const { comments, questions } = this.state;
    const { t, start_date, end_date, user } = this.props;

    const formatDate = (d) => {
      if (!d) return "-";
      if (typeof d === "object" && typeof d.format === "function") {
        return d.format("DD.MM.YYYY");
      }
      try {
        return new Date(d).toLocaleDateString("tr-TR");
      } catch (e) {
        return d;
      }
    };

    const formatLink = (link) => {
      if (!link || link === "#") return "-";
      if (!link.startsWith("http")) return "https://" + link;
      return link;
    };

    const generalData = [
      ["Rapor Oluşturulma Tarihi", new Date().toLocaleString("tr-TR")],
      ["", ""],
      ["Rapor Başlangıç Tarihi", formatDate(start_date)],
      ["Rapor Bitiş Tarihi", formatDate(end_date)],
      ["", ""],
      [t("TotalComments"), comments.length],
      [t("TotalQuestions"), questions.length],
      [
        t("NegativeDensity"),
        comments.filter((c) => c.extra && c.extra.rate < 3).length,
      ],
    ];

    const commentData = comments
    .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
    .map((item) => {  
      const extra = item.extra || {};
      return {
        [t("ProductName")]: extra.productName || `Ürün ID: ${item.product_id}`,
        "Ürün URL": formatLink(extra.absolute_url),
        Yorum: extra.comment || "-",
        Puan: extra.rate || "-",
        Tarih: extra.commentDateISOtype || "-",
      };
    });

    const questionData = questions
    .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
    .map((item) => {
      const extra = item.extra || {};
      return {
        [t("ProductName")]: extra.productName || `Ürün ID: ${item.product_id}`,
        "Ürün URL": formatLink(extra.product_link),
        Soru: extra.question || "-",
        Cevap: extra.answer?.text || "-",
        Tarih: formatDate(item.created_at) || "-", 
      };
    });

    const wb = XLSX.utils.book_new();

    const wsGeneral = XLSX.utils.aoa_to_sheet(generalData);
    const wsComments = XLSX.utils.json_to_sheet(commentData);
    const wsQuestions = XLSX.utils.json_to_sheet(questionData);

    wsGeneral["!cols"] = [{ wch: 25 }, { wch: 25 }];

    wsComments["!cols"] = [
      { wch: 30 },
      { wch: 40 },
      { wch: 60 },
      { wch: 10 },
      { wch: 15 },
    ];

    wsQuestions["!cols"] = [{ wch: 30 }, { wch: 40 }, { wch: 60 }, { wch: 60 }];

    XLSX.utils.book_append_sheet(wb, wsGeneral, "Genel Rapor");
    XLSX.utils.book_append_sheet(wb, wsComments, "Yorum Analitiği");
    XLSX.utils.book_append_sheet(wb, wsQuestions, "Soru-Cevap Analitiği");

    const fileName = `CollectAction Rapor - ${user.name || 'Kullanıcı'}.xlsx`;
    XLSX.writeFile(wb, fileName);
  };

  render() {
    const { loading, comments, questions } = this.state;
    let { t } = this.props;

    if (loading) return <div style={{ padding: 20 }}>{t("qaLoading")}</div>;

    const totalComments = comments.length;
    const totalQuestions = questions.length;

    const allCommentedProducts = this.groupByProduct(comments);
    const allAskedProducts = this.groupByProduct(questions);

    const visibleCommentedProducts = allCommentedProducts.slice(
      0,
      this.state.commentLimit
    );
    const visibleAskedProducts = allAskedProducts.slice(
      0,
      this.state.questionLimit
    );

    const totalNegativeIntensity = comments.filter(
      (c) => c.extra && c.extra.rate < 3
    ).length;
    const negativeCommentsList = this.getNegativeStats();

    return (
      <div
        style={{
          padding: "20px",
          backgroundColor: "#f8f9fa",
          minHeight: "100vh",
        }}
      >
        <div style={{ marginBottom: "20px", textAlign: "right" }}>
          <Button
            primary
            icon="file excel"
            content="Excel İndir"
            onClick={this.downloadExcel}
          />
        </div>
        <Grid stackable style={{ marginBottom: "10px" }}>
          <Grid.Row columns={3}>
            <Grid.Column>
              <Card fluid>
                <Card.Content textAlign="center" style={{ padding: "25px" }}>
                  <Statistic>
                    <Statistic.Value style={{ color: "#2185d0" }}>
                      {totalComments.toLocaleString()}
                    </Statistic.Value>
                    <Statistic.Label
                      style={{ fontSize: "14px", fontWeight: "bold" }}
                    >
                      {t("TotalComments")}
                    </Statistic.Label>
                  </Statistic>
                  <div
                    style={{
                      marginTop: "8px",
                      fontSize: "13px",
                      color: "#7f8c8d",
                    }}
                  >
                    <Icon name="comment alternate" /> {t("AllTimes")}
                  </div>
                </Card.Content>
              </Card>
            </Grid.Column>

            <Grid.Column>
              <Card fluid>
                <Card.Content textAlign="center" style={{ padding: "25px" }}>
                  <Statistic>
                    <Statistic.Value style={{ color: "#f2711c" }}>
                      {totalQuestions.toLocaleString()}
                    </Statistic.Value>
                    <Statistic.Label
                      style={{ fontSize: "14px", fontWeight: "bold" }}
                    >
                      {t("TotalQuestions")}
                    </Statistic.Label>
                  </Statistic>
                  <div
                    style={{
                      marginTop: "8px",
                      fontSize: "13px",
                      color: "#7f8c8d",
                    }}
                  >
                    <Icon name="question circle" /> {t("CustomerRequests")}
                  </div>
                </Card.Content>
              </Card>
            </Grid.Column>

            <Grid.Column>
              <Card fluid>
                <Card.Content textAlign="center" style={{ padding: "25px" }}>
                  <Statistic>
                    <Statistic.Value style={{ color: "#e74c3c" }}>
                      {totalNegativeIntensity.toLocaleString()}
                    </Statistic.Value>
                    <Statistic.Label
                      style={{ fontSize: "14px", fontWeight: "bold" }}
                    >
                      {t("NegativeDensity")}
                    </Statistic.Label>
                  </Statistic>
                  <div
                    style={{
                      marginTop: "8px",
                      fontSize: "13px",
                      color: "#7f8c8d",
                    }}
                  >
                    <Icon name="warning sign" /> {t("NegativeReviews")}
                  </div>
                </Card.Content>
              </Card>
            </Grid.Column>
          </Grid.Row>
        </Grid>

        <Grid stackable>
          <Grid.Row>
            <Grid.Column width={8}>
              <Segment style={{ padding: "20px" }}>
                <Header
                  as="h3"
                  style={{ marginBottom: "20px", color: "#2c3e50" }}
                >
                  <Icon name="chart bar" />
                  {t("MostCommentedProducts")}
                </Header>
                <Table celled striped>
                  <Table.Body>
                    {visibleCommentedProducts.map((item, index) => (
                      <Table.Row key={index}>
                        <Table.Cell>
                          <a
                            href={item.link}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ fontWeight: "bold", color: "#34495e" }}
                          >
                            {item.name}
                          </a>
                        </Table.Cell>
                        <Table.Cell textAlign="right">
                          <strong style={{ color: "#2185d0" }}>
                            {item.count}
                          </strong>
                        </Table.Cell>
                      </Table.Row>
                    ))}
                    {visibleCommentedProducts.length === 0 && (
                      <Table.Row>
                        <Table.Cell colSpan="2">
                          {t("NoDataAvailable")}
                        </Table.Cell>
                      </Table.Row>
                    )}
                  </Table.Body>
                </Table>

                {allCommentedProducts.length > this.state.commentLimit && (
                  <div style={{ textAlign: "center", marginTop: "10px" }}>
                    <Button
                      basic
                      color="blue"
                      onClick={() =>
                        this.setState({
                          commentLimit: this.state.commentLimit + 5,
                        })
                      }
                    >
                      Daha Fazla Göster
                    </Button>
                  </div>
                )}
              </Segment>
            </Grid.Column>

            <Grid.Column width={8}>
              <Segment style={{ padding: "20px" }}>
                <Header
                  as="h3"
                  style={{ marginBottom: "20px", color: "#2c3e50" }}
                >
                  <Icon name="help" />
                  {t("MostQuestionsProducts")}
                </Header>
                <Table celled striped>
                  <Table.Body>
                    {visibleAskedProducts.map((item, index) => (
                      <Table.Row key={index}>
                        <Table.Cell>
                          <a
                            href={item.link}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ fontWeight: "bold", color: "#34495e" }}
                          >
                            {item.name}
                          </a>
                        </Table.Cell>
                        <Table.Cell textAlign="right">
                          <strong style={{ color: "#f2711c" }}>
                            {item.count}
                          </strong>
                        </Table.Cell>
                      </Table.Row>
                    ))}
                    {visibleAskedProducts.length === 0 && (
                      <Table.Row>
                        <Table.Cell colSpan="2">
                          {t("NoDataAvailable")}
                        </Table.Cell>
                      </Table.Row>
                    )}
                  </Table.Body>
                </Table>

                {allAskedProducts.length > this.state.questionLimit && (
                  <div style={{ textAlign: "center", marginTop: "10px" }}>
                    <Button
                      basic
                      color="orange"
                      onClick={() =>
                        this.setState({
                          questionLimit: this.state.questionLimit + 5,
                        })
                      }
                    >
                      Daha Fazla Göster
                    </Button>
                  </div>
                )}
              </Segment>
            </Grid.Column>
          </Grid.Row>
        </Grid>

        <Grid stackable>
          <Grid.Row>
            <Grid.Column width={16}>
              <Segment style={{ padding: "20px" }}>
                <Header
                  as="h3"
                  style={{ marginBottom: "20px", color: "#c0392b" }}
                >
                  <Icon name="bug" />
                  {t("NegativeCommentDistribution")}
                </Header>
                <Table celled striped>
                  <Table.Header>
                    <Table.Row>
                      <Table.HeaderCell>{t("ProductName")}</Table.HeaderCell>
                      <Table.HeaderCell textAlign="right">
                        {t("NumberOfNegativeReviews")}
                      </Table.HeaderCell>
                      <Table.HeaderCell textAlign="right">
                        {t("ProblemShare")}
                      </Table.HeaderCell>
                    </Table.Row>
                  </Table.Header>
                  <Table.Body>
                    {negativeCommentsList.map((item, index) => (
                      <Table.Row key={index}>
                        <Table.Cell>
                          <a
                            href={item.link}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ fontWeight: "bold", color: "#2c3e50" }}
                          >
                            {item.name}
                          </a>
                        </Table.Cell>
                        <Table.Cell textAlign="right">{item.count}</Table.Cell>
                        <Table.Cell textAlign="right">
                          <span
                            style={{ color: "#e74c3c", fontWeight: "bold" }}
                          >
                            %{item.percentage}
                          </span>
                        </Table.Cell>
                      </Table.Row>
                    ))}
                    {negativeCommentsList.length === 0 && (
                      <Table.Row>
                        <Table.Cell
                          colSpan="3"
                          textAlign="center"
                          style={{ color: "#27ae60" }}
                        >
                          Negatif yorum bulunmuyor.
                        </Table.Cell>
                      </Table.Row>
                    )}
                  </Table.Body>
                </Table>
              </Segment>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>
    );
  }
}

export default connect((state) => ({
  product: state.product,
  user: state.access.user.loggedUserObj,
}))(withTranslation()(CommentQuestionAnalytic));
